const autocompleteModalCloneEquipModel = {
  group: 'Group'
};

export default autocompleteModalCloneEquipModel;
